import { render, staticRenderFns } from "./epb-select.component.vue?vue&type=template&id=72209f11&scoped=true"
import script from "./epb-select.component.vue?vue&type=script&lang=ts"
export * from "./epb-select.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-select.component.vue?vue&type=style&index=0&id=72209f11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72209f11",
  null
  
)

export default component.exports